// web/src/lib/zitchAgent/_worklet.ts —— 内部：AudioWorklet 源码（采集/播放处理器）
// 拆自 web/src/lib/zitchAgent.ts 的同名分区（内容原样搬运）；由 web/src/lib/zitchAgent.ts 以 export * 聚合，导出面对调用方不变。

export const WORKLET_SRC = `
class PcmCap extends AudioWorkletProcessor {
  process(inputs) {
    const ch = inputs[0][0];
    if (ch) this.port.postMessage(ch.slice(0));
    return true;
  }
}
registerProcessor('pcm-cap', PcmCap);

// 播放：8k L16 → 设备率的连续重采样 + 抖动缓冲，全部在音频线程内以单一读指针完成。
// 不用逐帧 AudioBufferSource：它每个 20ms 块独立做采样率转换，块边界反复重置滤波器 → 沙沙/噼啪。
// 重采样用 24 抽头窗函数 sinc 多相（48k/8k=6 相）；线性插值会高频衰减（发闷）且残留镜像（金属感）。
class PcmPlay extends AudioWorkletProcessor {
  constructor() {
    super();
    this.cap = 16384; // 环形缓冲容量（8k 样本，约 2s）
    this.buf = new Float32Array(this.cap);
    this.r = 0;       // 读下标
    this.w = 0;       // 写下标
    this.len = 0;     // 可读样本数
    this.step = 8000 / sampleRate; // 线性回落时的输入步进
    this.target = Math.round(8000 * 0.1); // 目标缓冲 100ms，吸收 WSS/TCP 抖动
    this.primed = false;
    this.frac = 0;    // 线性回落的小数读位置
    this.phase = 0;   // 多相相位（48k 下 0..5）
    this.last = 0;
    this.T = 12;      // 每侧 12 抽头 → 24 抽头
    this.poly = null;
    if (Math.abs(sampleRate - 48000) < 1) {
      const sinc = (x) => (x === 0 ? 1 : Math.sin(Math.PI * x) / (Math.PI * x));
      const win = (d) => (Math.abs(d) >= this.T ? 0 : 0.5 + 0.5 * Math.cos((Math.PI * d) / this.T));
      const ph = [];
      for (let p = 0; p < 6; p++) {
        const pos = p / 6;
        const c = [];
        let sum = 0;
        for (let k = -this.T + 1; k <= this.T; k++) {
          const v = sinc(pos - k) * win(pos - k);
          c.push(v);
          sum += v;
        }
        for (let i = 0; i < c.length; i++) c[i] /= sum; // 归一保证直流增益
        ph.push(c);
      }
      this.poly = ph;
    }
    this.port.onmessage = (e) => {
      const f = e.data;
      for (let i = 0; i < f.length; i++) {
        if (this.len >= this.cap) { this.r = (this.r + 1) % this.cap; this.len--; }
        this.buf[this.w] = f[i];
        this.w = (this.w + 1) % this.cap;
        this.len++;
      }
    };
  }
  process(inputs, outputs) {
    const out = outputs[0][0];
    for (let i = 0; i < out.length; i++) {
      if (!this.primed) {
        if (this.len < this.target) { out[i] = 0; continue; }
        this.primed = true;
        this.frac = 0;
        this.phase = 0;
      }
      // 缓冲过深（时钟漂移/突发）→ 跳到目标深度，避免时延无限累积
      if (this.len > this.target + 8000) {
        const drop = this.len - this.target;
        this.r = (this.r + drop) % this.cap;
        this.len -= drop;
        this.frac = 0;
        this.phase = 0;
      }
      if (this.poly) {
        if (this.len >= this.T + 2) {
          const c = this.poly[this.phase];
          let s = 0;
          for (let k = -this.T + 1, j = 0; k <= this.T; k++, j++) {
            s += this.buf[(this.r + k + this.cap) % this.cap] * c[j];
          }
          out[i] = s;
          this.last = s;
          this.phase++;
          if (this.phase >= 6) { this.phase = 0; this.r = (this.r + 1) % this.cap; this.len--; }
        } else {
          this.last *= 0.99; // 欠载：快速淡出，避免突变爆音
          out[i] = this.last;
        }
      } else if (this.len >= 2) {
        const a = this.buf[this.r];
        const b = this.buf[(this.r + 1) % this.cap];
        const s = a + (b - a) * this.frac;
        out[i] = s;
        this.last = s;
        this.frac += this.step;
        while (this.frac >= 1) { this.frac -= 1; this.r = (this.r + 1) % this.cap; this.len--; }
      } else {
        this.last *= 0.99;
        out[i] = this.last;
      }
    }
    return true;
  }
}
registerProcessor('pcm-play', PcmPlay);
`;

